import React from "react";

interface I18nProviderProps {
  children: React.ReactNode;
}

/**
 * Pass-through provider.
 *
 * i18next is seeded SYNCHRONOUSLY on both sides — on the server from disk
 * (entry-server.tsx) and on the client from `window.__I18N__` (i18n.ts) — so the
 * critical translations are present at first render and `t()` resolves them
 * immediately. There is therefore no need to gate rendering behind a loading
 * state. The previous full-screen loader gate caused the SSR hydration mismatch:
 * the client briefly rendered a fixed full-screen overlay the server never sent.
 */
export const I18nProvider: React.FC<I18nProviderProps> = ({ children }) => {
  return <>{children}</>;
};
